module.exports = __webpack_public_path__ + "img/logo.8d39c7a.svg";